import { restEmpty, simpleAlert, SubLine } from "components/CommonLib/CommonLib";
import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";
import { HttpInstance } from "lib/HttpLib";
import _ from "lodash";
import { globalModalOff, globalModalOn } from "modules/actions/Modal";
import { exportToCashBookExcel } from "pages/DailyReport/DailyReportInfo/DailyReportTabs/SalesTab/MakeExcel";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import IncomeExpenseAddModal from "../Modal/IncomeExpenseAddModal";
import { useCashBookStore } from "../modules/store/cashBookState";
import IncomeResultTable from "./IncomeResultTable";
import SearchCondition from "./SearchCondition";

const IncomeListContent = ({
  searchParam,
  setSearchParam,
  cashbookId,
  baseMonth,
  infoStateData,
}) => {
  const storesDispatch = useDispatch();

  // 페이지 상태 관리
  const [searchParamRef, setSearchParamRef] = useState(searchParam); // 조건초기화 용도
  const [searchResult, setSearchResult] = useState([]);
  const [curPage, setCurPage] = useState(1); // pagination
  const [totalPage, setTotalPage] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);

  // 전역 상태 관리
  const { setCashBookLoading: setLoading } = useCashBookStore();

  useEffect(() => {
    setSearchParamRef(searchParam);
  }, [searchParam]);

  const [typeList, setTypeList] = useState(["전체"]);

  useEffect(() => {
    getIncomeAccountList();
  }, []);

  const getIncomeAccountList = async () => {
    try {
      const res = await HttpInstance.get(
        process.env.REACT_APP_SALARY_SERVER + "/cashbook/account/list",
        {
          params: {
            account_type: "income",
          },
        },
      );

      if (!restEmpty(res.data.data)) {
        setTypeList(res.data.data);
      }
    } catch (err) {
      console.log(err);
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    }
  };

  const resetSearchParam = () => {
    setSearchParam({
      create_type: "",
      account: "",
      cashbook_id: cashbookId,
    });
  };

  const onClickSearch = (isExcel, page) => {
    const formData = new FormData();
    formData.append("search_param", JSON.stringify(searchParamRef));

    setCurPage(page);
    setLoading(true);

    HttpInstance.get(process.env.REACT_APP_SALARY_SERVER + "/cashbook/income/list", {
      params: {
        cashbook_id: cashbookId,
        create_type: searchParamRef.create_type,
        account: searchParamRef.account,
        cur_page: page,
        is_excel: isExcel,
      },
    })
      .then((res) => {
        if (res.data.msg) {
          simpleAlert(storesDispatch, "ERROR", res.data.msg);
        } else {
          if (isExcel) {
            exportToCashBookExcel(
              "수입상세",
              res.data.data,
              `${infoStateData.branch_info.branch_name}_${infoStateData.base_month}_수입상세내역`,
            );
          } else {
            setTotalPage(res.data.total_page);
            setTotalPrice(res.data.total_price);
            setSearchResult(res.data.data);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onModalDone = (res) => {
    storesDispatch(globalModalOff());
    onClickSearch(false, curPage);
  };

  const onClickAdd = () => {
    const param = {
      cashbookId: cashbookId,
      mode: "add",
      type: "income",
      typeList: typeList,
      baseMonth,
    };

    storesDispatch(
      globalModalOn({
        show: true,
        title: "수입 내역 추가",
        Content: <IncomeExpenseAddModal modalParam={param} onModalDone={onModalDone} />,
      }),
    );
  };

  const onClickEdit = (data) => {
    data.is_old = true; // 삭제버튼 표시 안하기 위함

    const param = {
      cashbookId: cashbookId,
      mode: "edit",
      type: "income",
      data: _.cloneDeep(data),
      typeList,
      baseMonth,
    };

    storesDispatch(
      globalModalOn({
        show: true,
        title: "수입 내역 수정",
        Content: <IncomeExpenseAddModal modalParam={param} onModalDone={onModalDone} />,
      }),
    );
  };

  const onClickDelete = (data) => {
    simpleAlert(storesDispatch, "알림", "삭제하시겠습니까?", false, undefined, () => {
      onDelete(data.item_id);
    });
  };

  const onDelete = async (itemId) => {
    HttpInstance.delete(process.env.REACT_APP_SALARY_SERVER + "/cashbook/income/delete", {
      params: {
        cashbook_id: cashbookId,
        item_id: itemId,
      },
    })
      .then((res) => {
        if (res.data.msg) {
          simpleAlert(storesDispatch, "ERROR", res.data.msg);
        } else {
          simpleAlert(storesDispatch, "알림", "삭제되었습니다.", true, () => {
            onClickSearch(false, curPage);
          });
        }
      })
      .catch((err) => {
        console.log(err);
        simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
      });
  };

  const getTotalPrice = () => {
    return searchResult.reduce((sum, cur) => {
      return sum + cur.price;
    }, 0);
  };

  return (
    <div>
      <div>
        <SearchCondition searchParam={searchParamRef} typeList={typeList} />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "0.75rem",
            gap: "0.25rem",
          }}
        >
          <NormalBtn
            theme="white"
            name="초기화"
            search
            onClick={() => {
              resetSearchParam();
            }}
          />
          <NormalBtn
            name="검색"
            search
            onClick={() => {
              onClickSearch(false, 1);
            }}
          />
        </div>
      </div>

      <SubLine />

      <div style={{ marginTop: "1rem" }}>
        <IncomeResultTable
          searchResult={searchResult}
          onClickEdit={onClickEdit}
          onClickDelete={onClickDelete}
          onClickSearch={onClickSearch}
          onClickAdd={onClickAdd}
          curPage={curPage}
          totalPage={totalPage}
          infoStateData={infoStateData}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0rem" }}>
        <TextField
          labelText="수입 금액 합계"
          labelWidth="6rem"
          textBoxWidth="10rem"
          textMarginRight="0rem"
          endAdornment="원"
          isNumber
          disabled
          defaultValue={totalPrice.toLocaleString()}
        />
      </div>
    </div>
  );
};
export default IncomeListContent;
